export type ItemDetectionStatus = 'detected' | 'not_seen_recently' | 'missing';

const DETECTED_WITHIN_DAYS = 7;
const NOT_SEEN_RECENTLY_WITHIN_DAYS = 30;

export function getItemDetectionStatus(item: {
  lastDetectedAt?: Date | string | null;
}): ItemDetectionStatus {
  const raw = item.lastDetectedAt;
  if (raw == null) return 'missing';

  const lastDetected = typeof raw === 'string' ? new Date(raw) : raw;
  if (Number.isNaN(lastDetected.getTime())) return 'missing';

  const now = new Date();
  const diffMs = now.getTime() - lastDetected.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  if (diffDays <= DETECTED_WITHIN_DAYS) return 'detected';
  if (diffDays <= NOT_SEEN_RECENTLY_WITHIN_DAYS) return 'not_seen_recently';
  return 'missing';
}
